/**
 * @param {HTMLImageElement} image
 */
async function playAnimatedImage(image) {
    const source = image.dataset.animatedSrc;
    delete image.dataset.animatedSrc;
    if (!source) return;

    const animated = new Image();
    animated.src = source;
    await animated.decode().catch(() => {});

    image.removeAttribute('srcset');
    image.src = source;
}

const visibilityObserver = new IntersectionObserver((entries) => {
    for (const entry of entries) {
        if (!entry.isIntersecting || !(entry.target instanceof HTMLImageElement)) continue;

        visibilityObserver.unobserve(entry.target);
        playAnimatedImage(entry.target);
    }
});

/** @param {ParentNode} root */
function observeAnimatedImages(root) {
    root.querySelectorAll('img[data-animated-src]').forEach((image) => visibilityObserver.observe(image));
}

observeAnimatedImages(document);

new MutationObserver((mutations) => {
    for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
            if (node instanceof Element) observeAnimatedImages(node);
        });
    }
}).observe(document.body, { childList: true, subtree: true });
